import {
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack
} from '@mui/material';
import { StyledTextField } from 'modules/components/layer01';
import { FormBaseLayout } from 'modules/components/layer10';

import * as ds from './dataService';
import { SaveDecision_Input } from 'generated/graphql';
import { DateTime } from 'luxon';

export type SaveDecisionFormProps = {
  id: string;
  installationId: string;
  handleClose: () => void;
};



/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SaveDecisionFormProps) => {
  const [
    fnSaveDecision,
    { loading }
  ] = ds.useSaveDecision();
  const form = ds.useFormState(props.id);

  const handleSubmit = async () => {
    const input: SaveDecision_Input = {
      id: form.formState.id,
      installationId: props.installationId,
      approved: form.formState.approved === 'true'
        ? true
        : form.formState.approved === 'false'
          ? false
          : undefined,
      dueDate: DateTime.fromFormat(form.formState.dueDate, 'yyyy-LL-dd')
    };
    await fnSaveDecision(input);
    props.handleClose();
  };
  return (
    <FormBaseLayout.FC
      handleCancel={() => {
        props.handleClose();
      }}
      handleSubmit={() => handleSubmit()}
      cancelButtonText='Cancel'
      isLoading={loading}
    >
      <Stack
        rowGap='1.25rem'
      >
        <FormControl>
          <RadioGroup
            row={true}
            value={form.formState.approved}
            onChange={(e) => {
              form.dispatch({
                type: 'UPDATE',
                payload: {
                  property: 'approved',
                  value: e.target.value
                }
              });

            }}
          >

            <FormControlLabel
              control={<Radio />}
              value='true'
              label='Approved'
            />
            <FormControlLabel
              control={<Radio />}
              value='false'
              label='Rejected'
            />
          </RadioGroup>
        </FormControl>
        <Button
          onClick={() => {
            form.dispatch({
              type: 'UPDATE',
              payload: {
                property: 'approved',
                value: ''
              }
            });
          }}
          color='error'
        >
          Remove Approval
        </Button>

        <StyledTextField.FC

          {...form.genFieldProps('dueDate')}
        />

      </Stack>
    </FormBaseLayout.FC>
  );
};
